import { render, staticRenderFns } from "./calendarText.vue?vue&type=template&id=05937c9f&scoped=true&"
import script from "./calendarText.vue?vue&type=script&lang=js&"
export * from "./calendarText.vue?vue&type=script&lang=js&"
import style0 from "./calendarText.vue?vue&type=style&index=0&id=05937c9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05937c9f",
  null
  
)

export default component.exports